import Tab, { TabProps } from '@mui/material/Tab/Tab';
import Tabs from '@mui/material/Tabs/Tabs';
import { useTranslations } from 'next-intl';
import { useParams } from 'next/dist/client/components/navigation';

import styles from '@/blocks/components/Controls/Tabs/styles.module.scss';
import { DeprecatedTabsOverflowContainer } from '@/blocks/components/DeprecatedTabs';
import { LinkI18n } from '@/i18n/routing';

import { ROOT_SLUG } from '@/app/[lang]/price-chart/[category]/data';

function NavTab(props: TabProps<typeof LinkI18n>) {
  return <Tab {...props} component={LinkI18n} scroll={false} disableRipple />;
}

export default function PriceChartCategoriesTabs() {
  const category = (useParams().category || ROOT_SLUG) as string;
  const tr = useTranslations();

  return (
    <DeprecatedTabsOverflowContainer>
      <Tabs variant={'scrollable'} className={styles.tabs} value={category} aria-label="nav tabs example">
        <NavTab
          label={tr.rich('pages.priceCharts.root.sections.markets.tabs.mostTraded')}
          href={'/price-chart'}
          value={ROOT_SLUG}
        />
        <NavTab
          label={tr.rich('pages.priceCharts.root.sections.markets.tabs.forex')}
          href={'/price-chart/currencies'}
          value={'currencies'}
        />
        <NavTab
          label={tr.rich('pages.priceCharts.root.sections.markets.tabs.indices')}
          href={'/price-chart/indices'}
          value={'indices'}
        />
        <NavTab
          label={tr.rich('pages.priceCharts.root.sections.markets.tabs.commodities')}
          href={'/price-chart/commodities'}
          value={'commodities'}
        />
        <NavTab
          label={tr.rich('pages.priceCharts.root.sections.markets.tabs.stocks')}
          href={'/price-chart/shares'}
          value={'shares'}
        />
        <NavTab
          label={tr.rich('pages.priceCharts.root.sections.markets.tabs.crypto')}
          href={'/price-chart/cryptocurrencies'}
          value={'cryptocurrencies'}
        />
      </Tabs>
    </DeprecatedTabsOverflowContainer>
  );
}
